import Index from './index.vue'
// import Create from './components/Create.vue'
import List from './components/List.vue'
// import Edit from './components/Edit.vue'

export default [
  {
    path: 'transaction',
    name: 'transaction',
    component: Index,
    title: 'transaction',
    redirect: { name: 'transaction-list' },
    children: [
      
      {
        path: 'list',
        name: 'transaction-list',
        component: List,
      },
      
    ],
  },
]
